var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"right-border",attrs:{"cols":"3"}},[_c('FilterNav')],1),_c('b-col',{attrs:{"cols":"9"}},[_c('Results')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }